import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Typography, Box } from '@mui/material';

const NotFound = () => {

  const navigate = useNavigate();

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header current="404"/>
      <Box
        component="div"
        p={"0 20px"}
        sx={{
          flexGrow: 1,
          m: '30px auto',
          maxWidth: '1400px',
          textAlign: 'center',
        }}
      >
        <Typography variant='title'>Página no encontrada</Typography>
        <Typography onClick={() => navigate("/")} variant='a'>Volver al Home</Typography>
      </Box>
      <Footer />
    </Box>
  );
}

export default NotFound;